import L from "leaflet";

export const tyreIcon = new L.Icon({
  iconUrl: "../../tyre.png",
  iconSize: [15, 15], // Size of the icon
  iconAnchor: [17, 35], // Point of the icon which will correspond to marker's location
  popupAnchor: [0, -35] // Point from which the popup should open relative to the iconAnchor
});
